import { Modal } from "ant-design-vue";
import Api from "@/api/userService";
import {
  showToast,
  toast_error_type,
  toast_success_type,
} from "@/utils/ShowCompUtils";
import ResultCodeType from "@/constant/ResultCodeType";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function UseRestart(vin: string) {
  const hastask = 1;
  const end = 0;
  const leisure = 0;

  console.log(vin);
  const openRestartFailed = (str: string) => {
    Modal.confirm({
      title: "车辆重启失败",
      content: str,
      okText: "确定",
      okCancel: false,
    });
  };
  let FailedMsg: string;

  const HandleRestartStatus = (success: boolean, msg: string) => {
    if (success) {
      showToast("重启指令下发成功", toast_success_type);
    } else {
      if (msg && msg != "null" && msg != null) {
        FailedMsg = msg + "中,⻋辆⽆法重启";
      } else {
        FailedMsg = "⻋辆⽆法重启";
      }
      openRestartFailed(FailedMsg);
    }
  };

  const Restart = (value: number) => {
    Api.RestartRequest(vin, value).then((val: any) => {
      if (val) {
        if (val?.err_no == ResultCodeType.success_200) {
          HandleRestartStatus(val.result.restart_status, val.result.msg);
        } else {
          showToast(val.err_msg, toast_error_type);
        }
      }
    });
  };
  const openRestart = () => {
    Modal.confirm({
      title: "继续重启",
      content: "车端有尚未结束的任务， 重启后是否继续执行?",
      okText: "重启后继续",
      cancelText: "重启后不继续",
      onOk() {
        Restart(hastask);
      },
      onCancel(action: any) {
        if (action == "cancel") {
          Restart(end);
        } else if (action == "close") {
          //
        }
      },
    });
  };

  const pollRequestTaskStatus = (val: any) => {
    //  判断重启过程是否有正在执行的任务
    console.log("val", val);
    if (val.has_task) {
      openRestart();
    } else {
      //无任务直接重启
      Restart(leisure);
    }
  };
  const taskStatusRequestF = (vin: string) => {
    Api.taskStatusRequest(vin).then((val: any) => {
      if (val) {
        console.log(val);
        if (val?.err_no == ResultCodeType.success_200) {
          pollRequestTaskStatus(val.result);
        } else {
          showToast(val.err_msg, toast_error_type);
        }
      }
    });
  };

  taskStatusRequestF(vin);
}
